module.exports = __webpack_public_path__ + "static/media/BMW@2x.43380ce4.png";